import React from "react";
import { Button, Card, Form } from 'react-bootstrap';
import MainLayout from "../../layouts/main-layout";
import { Box, Container } from "@mui/material";
import 'bootstrap/dist/css/bootstrap.min.css';

interface TodoItem {
  text: string;
  isDone: boolean;
}

interface TodoProps {
  todo: TodoItem;
  index: number;
  markTodo: (index: number) => void;
  removeTodo: (index: number) => void;
}


function Todo({ todo, index, markTodo, removeTodo }: TodoProps) {
  return (
    <div className="todo">
      <span data-testid="todoText" style={{ textDecoration: todo.isDone ? "line-through" : "" }}>{todo.text}</span>
      <div>
        <Button data-testid="markDone" variant="outline-success" onClick={() => markTodo(index)}>✓</Button>{' '}
        <Button data-testid="markRemove" variant="outline-danger" onClick={() => removeTodo(index)}>✕</Button>
      </div>
    </div>
  );
}


interface FormTodoProps {
  addTodo: (text: string) => void;
}
function FormTodo({ addTodo }: FormTodoProps) {
  const [value, setValue] = React.useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!value) return;
    addTodo(value);
    setValue("");
  };

  return (
    <Form onSubmit={handleSubmit}> 
      <Form.Group>
        <Form.Label><b>Add Todo</b></Form.Label>
        <Form.Control data-testid="inputTodo" type="text" className="input" value={value} onChange={e => setValue(e.target.value)} placeholder="Add new todo" />
      </Form.Group>
      <br></br>
      <Button data-testid="submitTodo" variant="primary mb-3" type="submit">
        Submit
      </Button>
    </Form>
  );
}


const TodoList = () => {
  const [todos, setTodos] = React.useState([
    {
      text: "This is a sampel todo",
      isDone: false
    }
  ]);

  const addTodo = (text: string) => {
    const newTodos = [...todos, { text: text, isDone: false }];
    setTodos(newTodos);
  };

  const markTodo = (index: number) => {
    const newTodos = [...todos];
    newTodos[index].isDone = true;
    setTodos(newTodos);
  };

  const removeTodo = (index: number) => {
    const newTodos = [...todos];
    newTodos.splice(index, 1);
    setTodos(newTodos);
  };

  return (
    <MainLayout>
      <Box
        sx={{
          bgcolor: 'background.paper',
          pt: 12,
          pb: 6,
        }}
      >
        <Container maxWidth="lg">
          <h1 className="text-center">Todo List</h1>
          <FormTodo addTodo={addTodo} />
          <div data-testid="todoList">
            {todos.map((todo, index) => (
              <Card key={'todo_'+index}>
                <Card.Body>
                  <Todo
                  key={index}
                  index={index}
                  todo={todo}
                  markTodo={markTodo}
                  removeTodo={removeTodo}
                  />
                </Card.Body>
              </Card>
            ))}
          </div>
        </Container>
      </Box>
    </MainLayout>
  );
}
export default TodoList;